/* eslint-disable react/prop-types */
import React from 'react';
import { assets, Button, FormikInputPassword, FormikSwitch } from "@febos-io/design";
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import classNames from 'classnames';
import { useTranslation } from '../../../hooks';

export function SecondOpinionConection({
  level, companyId, clinicId, initialValues
}) {
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log(values);
      }}
    >
      {(props) => (
        <>
          <div className="d-flex mt-2">
            <div className="flex-shrink-0">
              <img
                className="me-1"
                src={assets.pearl.PearlDentalImage}
                alt="Slack"
                height="38"
                width="38"
              />
            </div>
            <div className="d-flex align-item-center justify-content-between flex-grow-1">
              <div className="me-1">
                <p className="fw-bolder mb-0">Pearl Second Opinion</p>
                <span>IA</span>
              </div>
              <div className="mt-50 mt-sm-0">
                <div className="form-switch">
                  <FormikSwitch
                    id="connection-active"
                    name="active"
                    title={t('Internal control exam, at no cost to the patient')}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="accordion" id="accordion-panel-exams" key="panel-connection-pearl-body">
            <div className="accordion-item" key="panel-connection-pearl-body">
              <div
                id="panel-connection-pearl-body"
                className={classNames(
                  'accordion-collapse',
                  { collapse: !props.values.active }
                )}
                aria-labelledby="panel-connection-pearl-body"
              >
                <div className="accordion-body">
                  <div>
                    <FormikInputPassword
                      name="oficina_id"
                      placeholder="Id de oficina asociada"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Button type="submit">{t('Send')}</Button>
        </>
      )}
    </Formik>
  );
}

export default SecondOpinionConection;

SecondOpinionConection.propTypes = {
  companyId: PropTypes.string.isRequired,
  clinicId: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired
};
